module.exports = __webpack_public_path__ + "static/media/r29.1841d7c3.jpg";